import React, { FC, Fragment } from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';
import { currency } from '../../../../utils';
import { getInvoiceBalance } from '../../../../../../Components/InvoiceTool/InvoiceUtil';

const SmallScreenTable: FC<any> = ({ invoices }) => {
  return (
    <List>
      {invoices.map((invoice, index) => {
        const _total = getInvoiceBalance(invoice);
        return (
          <Fragment key={index}>
            <Card>
              <CardTop>
                <Mono>{invoice.invoiceNumber}</Mono>
                <DateText>{invoice && format(new Date(invoice.invoicedAt), 'yyyy-MM-dd')}</DateText>
              </CardTop>
              <CardRow $emphasis>
                <RowLabel>Amount</RowLabel>
                <PayAmount>{currency(_total)}</PayAmount>
              </CardRow>
            </Card>
          </Fragment>
        );
      })}
    </List>
  );
};

export default SmallScreenTable;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Card = styled.div`
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--neutral-0);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
`;

const Mono = styled.span`
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 0.8125rem;
  color: var(--neutral-700);
  background: var(--neutral-100);
  border: 1px solid var(--border);
  padding: 2px 8px;
  border-radius: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

const DateText = styled.span`
  font-size: 0.75rem;
  color: var(--neutral-600);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

const CardRow = styled.div<{ $emphasis?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: ${({ $emphasis }) => ($emphasis ? '8px 0 0' : '0')};
  border-top: ${({ $emphasis }) => ($emphasis ? '1px dashed var(--border)' : '0')};
  margin-top: ${({ $emphasis }) => ($emphasis ? '4px' : '0')};
`;

const RowLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const RowValue = styled.span`
  font-size: 0.875rem;
  font-variant-numeric: tabular-nums;
  color: var(--mainText);
`;

const RowValueMuted = styled(RowValue)`
  color: var(--neutral-600);
`;

const PayAmount = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: var(--success-700, #196a3b);
  font-variant-numeric: tabular-nums;
`;
